import { UsecaseValidationMessage } from "../UsecaseValidationMessage";
import { TaxAtSourceKind, TaxAtSourceUsecase, UserDefinedRow } from "../../model";
import { BaseUsecaseLogic } from "../BaseUsecaseLogic";
import { DatelyObject, Numeric } from "../../util";
import { RowUsecaseCalcData } from "../RowUsecaseCalcData";

/** Client-side logic for TaxAtSource  */
export class TaxAtSourceUsecaseLogic extends BaseUsecaseLogic {

  /**
   * Updates the usecase values based on user input without going to the server.
   * @param row Row to update.
   * @param _date The reference date for which the logic is done.
   * Typically the salary date of a calculation and the typically, the information needed is just the year for which the yearly changing numbers are fetched, but may later have more extended features.
   * @param _calcData The calculation related data that is required by the more complex calculations:
   * This data is available only after first round-trip to the server (results object exists) and not all user interfaces may provide this.
   */
  public updateUsecase(row: UserDefinedRow, _date: DatelyObject, _calcData: RowUsecaseCalcData): void {
    const data: TaxAtSourceUsecase = row.data || {};
    switch (data.kind) {
      case TaxAtSourceKind.DailyDeduction:
      case TaxAtSourceKind.MonthlyDeduction:
        data.deduction = data.deductionPrice * data.deductionCount;
        row.price = data.totalTaxable - data.deduction;
        row.count = data?.employmentData?.percent ?? 0;
        data.taxValue = row.price * row.count;
        break;
      case TaxAtSourceKind.FixedValues:
        // FIXED: data.deduction = data.deductionPrice * data.deductionCount;
        row.price = data.taxValue;
        row.count = 1;
        break;
      case TaxAtSourceKind.Undefined:
      case TaxAtSourceKind.NoDeduction:
        data.deduction = 0;
        row.price = data.totalTaxable;
        row.count = data.employmentData?.percent ?? 0;
        data.taxValue = row.price * row.count;
        break;
    }
  }

  /** Gets validation message*/
  protected getUcValidation?(row: UserDefinedRow): UsecaseValidationMessage {
    const data: TaxAtSourceUsecase = row.data || {};
    let msg = "-";
    switch (data.kind) {
      case TaxAtSourceKind.DailyDeduction:
      case TaxAtSourceKind.MonthlyDeduction:
        msg = `(${ Numeric.formatPrice(row.data.totalTaxable) } - ${ Numeric.formatPrice(row.data.deduction)} = ${Numeric.formatPrice(row.price)}) * ${Numeric.formatPercent(row.count * 100, null)} = ${ Numeric.formatPrice(row.data.taxValue) }`;
        break;
      case TaxAtSourceKind.FixedValues:
        msg = `Tulot: ${ Numeric.formatPrice(row.data.totalTaxable) } - ${ Numeric.formatPrice(row.data.deduction)} = ${Numeric.formatPrice(row.data.totalTaxable - row.data.deduction)}, Lähdevero: ${ Numeric.formatPrice(row.data.taxValue)}`;
        break;
      case TaxAtSourceKind.Undefined:
      case TaxAtSourceKind.NoDeduction:
        msg = `(${ Numeric.formatPrice(row.data.totalTaxable) } - ${ Numeric.formatPrice(row.data.deduction)}) * ${Numeric.formatPercent(row.count * 100, null)} = ${ Numeric.formatPrice(row.data.taxValue) }`;
        break;
    }
    return {
      msg,
      // TODO: Added validation errors
      type: "default",
    };
  }
}